"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DiscountCodeModel = exports.UsageHistoryModel = void 0;
const legacy_transformers_1 = require("@daytrip/legacy-transformers");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
class UsageHistoryModel {
}
exports.UsageHistoryModel = UsageHistoryModel;
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsDate)(),
    legacy_transformers_1.TransformToDate,
    __metadata("design:type", Date)
], UsageHistoryModel.prototype, "usedAt", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], UsageHistoryModel.prototype, "orderId", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], UsageHistoryModel.prototype, "userId", void 0);
class DiscountCodeModel {
}
exports.DiscountCodeModel = DiscountCodeModel;
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], DiscountCodeModel.prototype, "_id", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsUUID)("4"),
    __metadata("design:type", String)
], DiscountCodeModel.prototype, "discountCampaignId", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsDate)(),
    __metadata("design:type", Date)
], DiscountCodeModel.prototype, "createdAt", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], DiscountCodeModel.prototype, "remainingNumberOfUses", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], DiscountCodeModel.prototype, "generatedByEmail", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)(),
    (0, class_transformer_1.Type)(() => UsageHistoryModel),
    __metadata("design:type", Array)
], DiscountCodeModel.prototype, "usageHistory", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)(),
    __metadata("design:type", Array)
], DiscountCodeModel.prototype, "usedAt", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], DiscountCodeModel.prototype, "usedByUserId", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)(),
    __metadata("design:type", Array)
], DiscountCodeModel.prototype, "orderIds", void 0);
//# sourceMappingURL=discount-code.model.js.map